<template>

    <cms-view v-spinner="loading" :hide="loading">
        <cms-heading :title="pageTitle"></cms-heading>

        <cms-form-panel submit-button="Opslaan" :cancel-button="true" :submitting="submitting" @submit="submit">

            <cms-form-input title="Serienummer" name="serialNumber" v-model.trim="pendingLogger.serialNumber"
                            v-validate="'required'" data-vv-as="Serienummer" :error="error('serialNumber')"></cms-form-input>

            <cms-form-dropdown title="Type" v-model="pendingLogger.typeId" :options="typeOptions" searchable="true"
                               v-validate="'required'" data-vv-as="Type" :error="error('typeId')" data-vv-name="typeId"></cms-form-dropdown>

            <cms-form-input title="Eigenaar" name="owner" v-model.trim="pendingLogger.owner"
                            v-validate="'required'" data-vv-as="Eigenaar" :error="error('owner')"></cms-form-input>

            <cms-form-date-picker title="Datum aanschaf" name="purchaseDate" v-model.trim="pendingLogger.purchaseDate" input="true" :options="{ disableMobile: true }"
                            v-validate="'required'" data-vv-as="Datum aanschaf" :error="error('purchaseDate')"></cms-form-date-picker>

            <cms-form-input type="number" step="any" min="0" title="Aanschafwaarde" name="purchaseValue" v-model.trim="pendingLogger.purchaseValue"
                            v-validate="'required|min_value:0'" data-vv-as="Aanschafwaarde" :error="error('purchaseValue')"></cms-form-input>

            <cms-form-input title="Document referentienummer" name="documentReference" v-model.trim="pendingLogger.documentReference"></cms-form-input>

            <cms-form-textarea title="Opmerkingen" name="comments" v-model.trim="pendingLogger.comments"></cms-form-textarea>

        </cms-form-panel>
    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'

    import pick from 'lodash/pick'
    import clone from 'lodash/clone'
    import map from 'lodash/map'

    import LoggerQueries from 'app/queries/LoggerQueries'
    import LoggerTypeQueries from 'app/queries/LoggerTypeQueries'
    import LoggerMutations from 'app/mutations/LoggerMutations'

    @Component({

        name: 'logger-form',
        apollo: {

            loggerTypes: LoggerTypeQueries.all({ fetchPolicy: 'cache-and-network' }),

            logger: LoggerQueries.find({

                skip(){
                    return !this.$route.params.id;
                },

                result(result){

                    if(result && result.data) {

                        var logger = pick(result.data.viewer.findLogger, ['serialNumber', 'type', 'owner', 'purchaseDate', 'purchaseValue', 'documentReference', 'comments']);
                        logger.typeId = logger.type.id;
                        delete logger.type;

                        this.pendingLogger = logger;
                    }
                },

                variables(){

                    return {
                        loggerId: this.itemId,
                        actionFilter: null,
                        mutationSortField: null,
                        mutationSortDirection: null
                    }
                }
            })
        }
    })
    export default class extends Vue
    {
        data(){

            return {

                logger: null,
                pendingLogger: {
                    serialNumber: null,
                    typeId: null,
                    owner: null,
                    purchaseDate: null,
                    documentReference: null,
                    comments: null
                },

                loggerTypes: [],

                submitting: false,
                submitted: false,

                loading: 0
            }
        }

        breadcrumb(){

            return [{
                title: 'Overzicht loggers',
                route: {
                    name: 'loggers'
                }
            }, this.pageTitle];
        }

        created(){

            this.consoleLogger = this.$logger.child('LoggerForm');
        }

        get typeOptions(){

            return this.loggerTypes.items ? this.loggerTypes.items.map(type => ({ label: type.title, value: type.id })) : [];
        }

        get pageTitle(){

            var pageTitle = null;

            if(this.itemId){
                pageTitle = this.logger ? this.logger.serialNumber : '';
            }
            else {
                pageTitle = 'Logger toevoegen';
            }

            return pageTitle;
        }

        get itemId(){

            return this.$route.params.id;
        }

        onQueryError(){

            this.$toast.error('De logger kon niet worden opgehaald');
        }

        error(field){

            return this.submitted ? this.errors.first(field) : null;
        }

        submit(){

            this.submitted = true;

            this.$validator.validateAll().then(success => {

                if (!success) {

                    this.$toast.error('Er zijn één of meerdere fouten');
                    return;
                }

                this.submitting = true;
                var loggerData = {
                    ...clone(this.pendingLogger),
                    purchaseValue: this.pendingLogger.purchaseValue ? parseFloat(this.pendingLogger.purchaseValue) : null
                }

                if(this.logger) {

                    loggerData.id = this.logger.id;

                    LoggerMutations.update(loggerData).then(() => {

                        this.consoleLogger.info('Logger updated');
                        this.$toast.success('De logger is opgeslagen');

                        this.submitting = false;

                        this.$router.push({
                            name: 'logger-view',
                            params: { id: this.logger.id }
                        });

                    }).catch(e => this.handleSubmitError(e));
                }
                else {

                    LoggerMutations.create(loggerData).then((response) => {

                        this.consoleLogger.info('Logger created', response);
                        this.$toast.success('De logger is aangemaakt');

                        this.submitting = false;

                        this.$router.push({
                            name: 'logger-view',
                            params: { id: response.data.createLogger.id }
                        });

                    }).catch(e => this.handleSubmitError(e));
                }
            });
        }

        handleSubmitError(e){

            const errors = map(e.graphQLErrors, 'message');
            this.consoleLogger.error('Error saving logger', e);

            if(errors.indexOf('serial-number-taken') >= 0){
                this.$toast.error('Het gekozen serienummer is al in gebruik');
            }
            else {
                this.$toast.error('De logger kon niet worden opgeslagen');
            }

            this.submitting = false;
        }
    }

</script>
